import type { ImageType } from '@we-make-websites/ui-lib';
import type { FranchiseBlock } from 'components/plpContext/types/storePLP';
import type { Collection } from 'lib/contentful/__generated__/types';

/**
 * Get franchise block data for a collection.
 * @param collection - collection data
 * @returns franchise block data
 */
export const formatCollectionIntroBlock = (
  entryContent: Collection | undefined
): FranchiseBlock | undefined => {
  if (!entryContent) {
    return;
  }

  if (
    !(
      entryContent.franchiseBlockDescription || entryContent.franchiseBlockTitle
    )
  ) {
    return;
  }

  let theme: FranchiseBlock['theme'] = 'light';
  if (entryContent.franchiseBlockTheme === 'dark') {
    theme = 'dark';
  }

  const franchiseBlock: FranchiseBlock = {
    title: entryContent.franchiseBlockTitle ?? '',
    description: entryContent.franchiseBlockDescription ?? '',
    featuresTitle: entryContent.franchiseFeaturesTitle ?? '',
    icons: [],
    theme,
  };

  const franchiseIconsData =
    (entryContent.franchiseBlockIconsCollection?.items as ImageType[]) ??
    ([] as ImageType[]);

  franchiseBlock.icons = franchiseIconsData;

  return franchiseBlock;
};
